import CustomDatePickerInput from "../../../../components/CustomDatePickerInput";
import React, { useEffect } from "react";
import { useField } from "react-final-form";

interface IStartDateInput {
  record: any;
}

const StartDateInput = ({ record }: IStartDateInput) => {
  const nextEffectiveDate = useField("nextEffectiveDate");
  const {
    input: { onChange },
  } = useField("route.assignedSubcontractor.startDate");

  useEffect(() => {
    if (record) {
      if (record.startDate) {
        onChange(record.startDate);
      }
    }
  }, [record]);

  return (
    <CustomDatePickerInput
      name="route.assignedSubcontractor.startDate"
      label="Subcontractor Start Date *"
      min={nextEffectiveDate.input.value}
    />
  );
};

export default StartDateInput;
